import {ProModal} from 'Components/ProModal';
import styles from './index.module.scss';
import UploadArea from './UploadArea';
import React, {useState} from 'react';
import useRequestFn from '../../../Utils/Hooks/useRequestFn';
import {message, Modal, ModalProps} from 'antd';
import {errorMessage} from '../../../Utils/common';
import {LinkButton} from '../../Buttons/LinkButton';
import {isEmpty} from '../../../Stores/commonStore';

const DefaultFileSize = 1024 * 1024 * 5; // 5M

interface ModalImportProps extends ModalProps {
    subTitle?: React.ReactNode; // 左上角副标题
    accept?: string;
    size?: number; // 字节数
    tip?: React.ReactNode; // 导入说明
    steps?: React.ReactNode;
    restSteps?: React.ReactNode; // 导入步骤
    templateName?: string;
    templateUrl?: string;
    onUpload(file: File): Promise<unknown>;
    ajaxDownloadFun?(): Promise<unknown>;
}

export default function ModalImport({
    subTitle,
    accept = '.xlsx,.xls',
    size = DefaultFileSize,
    tip,
    steps,
    restSteps,
    templateName,
    templateUrl,
    onUpload,
    ajaxDownloadFun,
    ...props
}: ModalImportProps) {
    const [file, setFile] = useState<File | undefined>(undefined);

    const [onSubmit, {loading}] = useRequestFn(async () => {
        if (!file) {
            message.warning('还没有上传文件');
            return;
        }

        try {
            await onUpload(file);
            message.success('导入成功!');
        } catch (e) {
            Modal.error({content: <pre>{errorMessage(e)}</pre>});
        } finally {
            setFile(undefined);
        }
    });

    function onSelect(file: File) {
        setFile(file);
    }

    return (
        <ProModal
            className={styles.root}
            width={600}
            {...props}
            okButtonProps={{disabled: !file}}
            onOk={onSubmit}
            confirmLoading={loading}>
            <div className={styles.tip}>
                {!steps && (
                    <div>
                        {subTitle}

                        <div>
                            1.&nbsp;
                            <span className={styles.template}>
                                {isEmpty(ajaxDownloadFun) && templateUrl && (
                                    <a
                                        href={templateUrl}
                                        referrerPolicy="no-referrer">
                                        点击下载
                                    </a>
                                )}
                                {ajaxDownloadFun && (
                                    <LinkButton onClick={ajaxDownloadFun}>
                                        点击下载
                                    </LinkButton>
                                )}
                                &nbsp;《{templateName}》
                            </span>
                        </div>

                        {restSteps}
                    </div>
                )}

                {steps}
            </div>

            <UploadArea
                accept={accept}
                size={size}
                onSelect={onSelect}
                tip={tip}
            />
        </ProModal>
    );
}
